.track {
	position: fixed;
	top: 0;
	right: 0;
	// Above .fixed-top (1030), below modal/offcanvas layers (~1050+)
	z-index: 1035;
	box-sizing: border-box;
	width: var(--custom-scrollbar-track-width, 12px);
	height: 100vh;
	height: 100dvh;
	padding: 2px;
	pointer-events: auto;
	touch-action: pan-y;
}

.trackInner {
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 999px;
	background-color: rgba(var(--bs-tertiary-bg-rgb), 0.35);
}

.thumb {
	position: absolute;
	right: 0;
	left: 0;
	cursor: grab;
	touch-action: none;
	border-radius: 999px;
	background-color: rgba(var(--bs-secondary-rgb), 0.45);
	transition: background-color 0.12s ease;

	&:hover {
		background-color: rgba(var(--bs-secondary-rgb), 0.65);
	}
}
